import { EnumStagingStatus, type UpdateStagingStatusRequest } from '@Model';
import { Result, useToasts, useSynqoHttp } from '@synqo/frontend-component-library';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

export function useUpdateStagingStatus(apiResourcePath: string, refetchTable?: () => void) {
    const http = useSynqoHttp(apiResourcePath);
    const { pushAllToasts } = useToasts();

    const { mutateAsync } = useMutation({
        mutationFn: (request: UpdateStagingStatusRequest) =>
            http.patch<Result<boolean>, UpdateStagingStatusRequest>('staging_status', request),
        onSettled: (data) => {
            if (data) pushAllToasts(data.messages);
        },
        onSuccess: refetchTable,
    });

    const importObjects = useCallback(
        (ids: string[]) =>
            mutateAsync({
                object_ids: ids,
                staging_status: EnumStagingStatus.Imported,
                remarks: '',
            }),
        [mutateAsync],
    );

    const markAsSeen = useCallback(
        (ids: string[]) =>
            mutateAsync({
                object_ids: ids,
                staging_status: EnumStagingStatus.Seen,
                remarks: '',
            }),
        [mutateAsync],
    );

    const rejectObjects = useCallback(
        (ids: string[], reason: string) =>
            mutateAsync({
                object_ids: ids,
                staging_status: EnumStagingStatus.Rejected,
                remarks: reason,
            }),
        [mutateAsync],
    );

    return {
        importObjects,
        markAsSeen,
        rejectObjects,
    };
}
